import { API } from "../urls";

const getHeaders = () => ({ "Content-Type": "application/json" });
const fetchOpts = { credentials: "include" };

export const fetchParasutSettings = async (companyId) => {
    const res = await fetch(API.parasut_settings_company(companyId), { ...fetchOpts, headers: getHeaders() });
    return res.json();
};

export const upsertParasutSettings = async (data) => {
    const res = await fetch(API.parasut_settings_upsert, {
        method: "POST", ...fetchOpts, headers: getHeaders(), body: JSON.stringify(data),
    });
    return res.json();
};

export const deleteParasutSettings = async (id) => {
    const res = await fetch(API.parasut_settings_delete(id), { method: "DELETE", ...fetchOpts, headers: getHeaders() });
    return res.json();
};

export const fetchParasutConnectUrl = async (companyId) => {
    const res = await fetch(API.parasut_connect_url(companyId), { ...fetchOpts, headers: getHeaders() });
    return res.json();
};

export const fetchParasutAccounts = async (companyId) => {
    const res = await fetch(API.parasut_accounts(companyId), { ...fetchOpts, headers: getHeaders() });
    return res.json();
};

export const fetchParasutSyncQueue = async (companyId, { status, page, size } = {}) => {
    const res = await fetch(API.parasut_sync_queue(companyId, { status, page, size }), { ...fetchOpts, headers: getHeaders() });
    return res.json();
};

export const retryParasutSyncItem = async (companyId, queueId) => {
    const res = await fetch(API.parasut_sync_queue_retry(companyId, queueId), { method: "POST", ...fetchOpts, headers: getHeaders() });
    return res.json();
};
